import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import WhatsAppButton from './components/WhatsAppButton';
import api from './api';
import './index.css';

// Public pages
import Home          from './pages/Home';
import Products      from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Contact       from './pages/Contact';

// Admin pages
import AdminLogin     from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminProducts  from './pages/AdminProducts';
import AdminSections  from './pages/AdminSections';
import AdminOrders    from './pages/AdminOrders';
import AdminSettings  from './pages/AdminSettings';
import AdminSupport   from './pages/AdminSupport';

const TrackVisit = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    api.post('/api/visits', { page: location.pathname }).catch(() => {});
  }, [location.pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <WhatsAppButton />
  </>
);

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <TrackVisit />  {/* ✅ Maintenant INSIDE BrowserRouter = accès à useLocation */}
      <Routes>
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/products" element={<PublicLayout><Products /></PublicLayout>} />
        <Route path="/products/:id" element={<PublicLayout><ProductDetail /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />

        <Route path="/admin/login"     element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/products"  element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
        <Route path="/admin/sections"  element={<ProtectedRoute><AdminSections /></ProtectedRoute>} />
        <Route path="/admin/orders"    element={<ProtectedRoute><AdminOrders /></ProtectedRoute>} />
        <Route path="/admin/settings"  element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
        <Route path="/admin/support"   element={<ProtectedRoute><AdminSupport /></ProtectedRoute>} />

        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="*"      element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

export default App;